var qtranslate_controller = {
	updateLanguageSwitcherUrls: function () {
		updateLanguageSwitcherUrls()
	},
	i: function () {
		i()
	},
}

var i = function () {
	if (layData.is_qtranslate_active == 1) {
		window.laytheme.on('newpageshown', function () {
			setTimeout(updateLanguageSwitcherUrls, 0)
		})
	}
}

var escapeSelector = function (value) {
	if (window.CSS && typeof window.CSS.escape == 'function') {
		return window.CSS.escape(value)
	}
	return value.replace(/([ #;?%&,.+*~':"!^$[\]()=>|/@])/g, '\\$1')
}

var updateDropdownsForLanguageChooser = function () {
	jQuery('.qtranxs_language_chooser').each(function () {
		var $chooser = jQuery(this)
		var $select = jQuery('#qtranxs_select_' + $chooser.attr('id'))
		if ($select.length == 0) {
			$select = $chooser.prev('select[id^="qtranxs_select_"]')
		}
		if ($select.length == 0) {
			return
		}

		$chooser.find('li').each(function (ix) {
			var href = jQuery(this).find('a').first().attr('href')
			if (typeof href == 'string') {
				$select.find('option').eq(ix).val(href)
			}
			if (jQuery(this).hasClass('active')) {
				$select.find('option').eq(ix).prop('selected', true)
			}
		})
	})
}

var updateLinksForLanguage = function (lang, href) {
	if (typeof lang != 'string' || lang == '' || typeof href != 'string') {
		return
	}
	var selectorLang = escapeSelector(lang)
	var selectors = [
		'.qtranxs-lang-menu-item-' + selectorLang + ' a',
		'.qtranxs_language_chooser li.lang-' + selectorLang + ' a',
		'.qtranxs_language_chooser li.language-chooser-item-' + selectorLang + ' a',
		'.qtranxs_language_chooser a.qtranxs_image_' + selectorLang,
		'.qtranxs_language_chooser a.qtranxs_text_' + selectorLang,
		'.qtranxs_language_chooser a.qtranxs_css_' + selectorLang,
		'.qtranxs_language_chooser a.qtranxs_flag_' + selectorLang,
		'.qtranxs_language_chooser a.qtranxs_short_' + selectorLang,
	]
	jQuery(selectors.join(',')).attr('href', href)
}

var updateLanguageSwitcherUrls = function () {
	if (layData.is_qtranslate_active == 1) {
		jQuery.ajax({
			url: layData.wpapiroot + 'laytheme/v1/get_qtranslate_langswitcher_urls/',
			data: { url: window.location.href },
			method: 'GET',
			success: function (data) {
				var result = JSON.parse(data)
				for (var i = 0; i < result.length; i++) {
					// New response: [language code, href, hreflang].
					// Old response: [hreflang, href]. Keep the old shape as
					// a fallback for cached/plugin-mixed environments.
					updateLinksForLanguage(result[i][0], result[i][1])
					updateLinksForLanguage(result[i][2], result[i][1])
				}
				updateDropdownsForLanguageChooser()
			},
		})
	}
}

export default qtranslate_controller
